/** Asterisk marking a mandatory field's label. */
export function RequiredIndicator() {
  return <span className="gcw:text-text-primary"> *</span>;
}
